import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitInfoTextExtensionInterface } from '../../../extension/interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { FitnessBenefitInfoTextExtension } from './extension/fitness-benefit-info-text.extension';
import { FitnessBenefitMetadataExtension } from './extension/fitness-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('fitness')
    .add(BenefitMetadataExtensionInterface, new FitnessBenefitMetadataExtension())
    .add(BenefitInfoTextExtensionInterface, new FitnessBenefitInfoTextExtension())
    .build(),
);
